// Purpose: Defines the list of Clone plus (licensing) plans and their max user count.
// This is used to determine whether the user is allowed to use the Clone plus given current number
// of seats in monday.com.

interface MaxUserCountMapping {
  [plan_id: string]: number;
}

export const plans: MaxUserCountMapping = {
  plan_ver_a_3_users: 3,
  plan_ver_a_5_users: 5,
  plan_ver_a_10_users: 10,
  plan_ver_a_15_users: 15,
  plan_ver_a_20_users: 20,
  plan_ver_a_25_users: 25,
  plan_ver_a_30_users: 30,
  plan_ver_a_40_users: 40,
  plan_ver_a_50_users: 50,
  plan_ver_a_100_users: 100,
  plan_ver_a_200_users: 200,
  plan_ver_a_300_users: 300,
  plan_ver_a_400_users: 400,
  plan_ver_a_500_users: 500,
  plan_ver_a_1000_users: 1000,
  plan_ver_a_1500_users: 1500,
  plan_ver_a_2000_users: 2000,
  plan_ver_a_2500_users: 2500,
  plan_ver_a_3000_users: 3000,
  plan_ver_a_4000_users: 4000,
  plan_ver_a_5000_users: 5000,
  plan_ver_a_6000_users: 6000,
  plan_ver_a_7000_users: 7000,
  plan_ver_a_8000_users: 8000,
  plan_ver_a_9000_users: 9000,
  plan_ver_a_10000_users: 10000,
};
